import writeXlsxFile from "write-excel-file";
import { getAllSpeakers } from "../../../utils/services/speaker";
import moment from "moment";

export async function createXlsx({
  idEvent,
  limit,
  countData,
  setFinishExport,
}) {
  function formatDate(date) {
    if (date) {
      return moment(date).format("DD/MM/YYYY - H:mm");
    } else return "";
  }

  const schema = [
    {
      column: "ID do Evento",
      type: String,
      value: (palestrante) => palestrante.eventId,
    },
    {
      column: "Nome do Evento",
      type: String,
      value: (palestrante) => palestrante.eventTitle,
    },
    {
      column: "ID do Palestrante",
      type: String,
      value: (palestrante) => palestrante.id,
    },
    {
      column: "Nome Palestrante",
      type: String,
      value: (palestrante) => palestrante.name,
    },
    {
      column: "Foto",
      type: String,
      value: (palestrante) => palestrante.photo,
    },
    {
      column: "Sobre",
      type: String,
      value: (palestrante) => palestrante.about,
    },
    {
      column: "Empresa/Cargo/Especialidade",
      type: String,
      value: (palestrante) => palestrante.position,
    },
    {
      column: "Facebook",
      type: String,
      value: (palestrante) => palestrante.facebook,
    },
    {
      column: "Instagram",
      type: String,
      value: (palestrante) => palestrante.instagram,
    },
    {
      column: "LinkedIn",
      type: String,
      value: (palestrante) => palestrante.linkedin,
    },
    {
      column: "WhatsApp",
      type: String,
      value: (palestrante) => palestrante.whatsapp,
    },
    {
      column: "Site",
      type: String,
      value: (palestrante) => palestrante.site,
    },
    {
      column: "Categoria",
      type: String,
      value: (palestrante) => palestrante.category,
    },
    {
      column: "Cor",
      type: String,
      value: (palestrante) => palestrante.color,
    },
    {
      column: "Ordem",
      type: String,
      value: (palestrante) => palestrante.order,
    },
    {
      column: "ID Agendas",
      type: String,
      value: (palestrante) =>
        palestrante.agendas
          ? palestrante.agendas.map((a) => a.id).join(",")
          : "",
    },
    {
      column: "Nome Agendas",
      type: String,
      value: (palestrante) =>
        palestrante.agendas
          ? palestrante.agendas.map((a) => a.title).join(", ")
          : "",
    },
    {
      column: "Data e Hora da Criação",
      type: String,
      value: (participant) => formatDate(participant.createdAt),
    },
    {
      column: "Data e Hora da Atualização",
      type: String,
      value: (participant) => formatDate(participant.updatedAt),
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getAllSpeakers(idEvent, i, limit, "", "");
    // }).then((response) => console.log(response));
    // return;

    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  const allDataInSingleArray = allRequestsPromises
    .map((e) => e.data.findAllPalestrantes.data)
    .flat();
  if (allDataInSingleArray) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "palestrantes.xlsx",
    });
  }
}
